import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { GET_VIDEO_SETTINGS } from '@lib/apollo';
import SettingsModal from '@organisms/modals/SettingsModal';
import { UserContext } from '@lib/contexts/UserProvider';
import { videoSettingsModalOpenVar, videoSettingsVar } from '@lib/apollo';
import { usePatchUserMutation } from '@gql/generated';
import Icon from '@components/Icon';

const Button = styled.button`
  display: flex;
  align-items: center;
  color: rgb(36, 36, 36);
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  border: none;
  cursor: pointer;

  i {
    margin: 0 5px;
  }
`;

const VideoSettings = ({ className = '', button_text }) => {
  const [
    currentUser,
    { loading: loadingUserPreferences, refetch: refetchUser },
  ] = useContext(UserContext);
  const { data: videoSettingsData, loading: loadingVideoSettings } =
    useQuery(GET_VIDEO_SETTINGS);

  const [patchUser, { loading: patchingUser }] = usePatchUserMutation();

  useEffect(() => {
    // when preferences are loaded
    if (currentUser?.preferences) {
      let contentLanguages = currentUser?.preferences?.contentLanguages;
      if (!contentLanguages?.length) {
        contentLanguages = ['en', 'se', 'fi', 'no'];
      }
      const { excludeTerms, videoLevels } = currentUser.preferences;
      videoSettingsVar({
        excludeTerms,
        videoLevels,
        contentLanguages,
      });
    }

    return () => {
      refetchUser({ onlyBaseProperties: true });
    };
  }, [currentUser?.preferences]);

  const openSettingModal = () => {
    videoSettingsModalOpenVar(true);
  };

  if (loadingUserPreferences || loadingVideoSettings) return null;

  return (
    <React.Fragment>
      <Button
        className={className}
        onClick={() => {
          openSettingModal();
        }}
      >
        {button_text} <Icon name="ygb-icon-settings" fontSize="14px" />
      </Button>

      {/* Modal */}
      <SettingsModal
        videoSettings={videoSettingsData.videoSettings}
        handleSave={async (variables) => {
          // update reactive var -> reload taxonomies
          videoSettingsVar(variables);
          if (currentUser?.id) {
            // update user preferences...
            patchUser({
              variables,
            });
          }
          // close modal
          videoSettingsModalOpenVar(false);
        }}
        loading={patchingUser}
      />
    </React.Fragment>
  );
};

export default VideoSettings;
